import { useLang } from "@/lib/i18n";

export default function Marquee() {
  const { t } = useLang();
  const row = [...t.marquee.items, ...t.marquee.items];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-[#272B36] bg-[#14161C] py-5"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee items-center">
        {row.map((item, i) => (
          <span key={i} className="flex items-center whitespace-nowrap">
            <span className="font-display text-2xl font-semibold uppercase tracking-wide text-[#F8FAFC]/90 sm:text-3xl">
              {item}
            </span>
            <span className="mx-10 inline-block h-2.5 w-2.5 rotate-45 bg-[#E65100]" />
          </span>
        ))}
      </div>
    </div>
  );
}
